/**
 * Dynamically applies PWA settings fetched from SIAKAD backend to the DOM elements.
 * @param {Object} pwa - PWA configuration object from backend
 */
export function applyPwaSettings(pwa) {
  if (!pwa) return;

  // 1. Update Document Title
  if (pwa.pwa_name) {
    document.title = pwa.pwa_name;
  }

  // 2. Update Theme Color & Tile Color Meta Tags
  if (pwa.pwa_theme_color) {
    let metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (!metaThemeColor) {
      metaThemeColor = document.createElement('meta');
      metaThemeColor.name = 'theme-color';
      document.head.appendChild(metaThemeColor);
    }
    metaThemeColor.setAttribute('content', pwa.pwa_theme_color);

    let metaTileColor = document.querySelector('meta[name="msapplication-TileColor"]');
    if (!metaTileColor) {
      metaTileColor = document.createElement('meta');
      metaTileColor.name = 'msapplication-TileColor';
      document.head.appendChild(metaTileColor);
    }
    metaTileColor.setAttribute('content', pwa.pwa_theme_color);
  }

  // 3. Update Apple Mobile Web App Title
  if (pwa.pwa_short_name || pwa.pwa_name) {
    let metaAppleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (!metaAppleTitle) {
      metaAppleTitle = document.createElement('meta');
      metaAppleTitle.name = 'apple-mobile-web-app-title';
      document.head.appendChild(metaAppleTitle);
    }
    metaAppleTitle.setAttribute('content', pwa.pwa_short_name || pwa.pwa_name);
  }

  // 4. Update Favicon & Apple Touch Icon
  if (pwa.pwa_icon) {
    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (!appleTouchIcon) {
      appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      document.head.appendChild(appleTouchIcon);
    }
    appleTouchIcon.setAttribute('href', pwa.pwa_icon);

    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.setAttribute('href', pwa.pwa_icon);
  }

  // 5. Dynamic Web Manifest Link
  let manifestLink = document.querySelector('link[rel="manifest"]');
  if (pwa.pwa_enable === false) {
    if (manifestLink) {
      manifestLink.remove();
    }
  } else {
    if (!manifestLink) {
      manifestLink = document.createElement('link');
      manifestLink.rel = 'manifest';
      document.head.appendChild(manifestLink);
    }

    const iconUrl = pwa.pwa_icon || 'img/icons/icon.png';
    const name = pwa.pwa_name || 'Garapedu Lokal';
    const shortName = pwa.pwa_short_name || name;

    const dynamicManifest = {
      name: name,
      short_name: shortName,
      start_url: './',
      display: 'standalone',
      background_color: '#ffffff',
      theme_color: pwa.pwa_theme_color || '#ec5958',
      icons: [
        { src: iconUrl, sizes: '192x192', type: 'image/png', purpose: 'any' },
        { src: iconUrl, sizes: '512x512', type: 'image/png', purpose: 'any' },
        { src: iconUrl, sizes: '192x192', type: 'image/png', purpose: 'maskable' },
        { src: iconUrl, sizes: '512x512', type: 'image/png', purpose: 'maskable' }
      ]
    };

    const stringManifest = JSON.stringify(dynamicManifest);
    const dataUri = 'data:application/manifest+json;charset=utf-8,' + encodeURIComponent(stringManifest);
    manifestLink.setAttribute('href', dataUri);
  }
}
